// fetchBroadPictureText.js
// DAS-2554: fetch the latest Broad Picture as a ready-to-inject prompt block
// (Broad_Picture.prompt_ready_text) for the Select-Now per-ticker LLM check.
// Returns the markdown string, or null if unavailable. Never throws.
// Memoized with a short TTL so a "Check all Buy" batch fetches it once.
import api from './api';

const TTL_MS = 120000; // 2 min
let _cache = { ts: 0, text: null };

export async function fetchBroadPictureText() {
  if (_cache.ts && Date.now() - _cache.ts < TTL_MS) {
    return _cache.text;
  }
  try {
    const res = await api.get('/broad_picture');
    _cache = { ts: Date.now(), text: res.data?.latest?.prompt_ready_text || null };
    return _cache.text;
  } catch (_) {
    return _cache.text || null;
  }
}

// Wraps the block with a header for prompt injection, or '' if none.
export function broadPicturePromptBlock(text) {
  return text ? `\n\n--- CURRENT MARKET REGIME (Broad Picture) ---\n${text}\n` : '';
}
